module.exports = __webpack_public_path__ + "static/media/teapot_01.64904416.png";